import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';

import { MoneyListComponent } from './list/money-list.component';
import { FormNewComponent } from './form/form-new.component';


import { ActionButtonModule } from '../../../../shared/action-button';
import { LiveSearchSelectModule } from '../../../../shared/live-search-select';
import { FilterModule } from '../../../../shared/filter';
import { WidgetModule } from '../../../../shared/widget';
import { DatePickerModule } from '../../../../shared/date-picker';
import { ContainerModule } from '../../../../shared/container';
import { ListContainerModule } from '../../../../shared/list-container';
import { TableModule } from '../../../../shared/table';

import {
    UnitProviders, InvestorProviders, CategoryProviders, PropertyProviders, LesseeProviders
} from '../../../../_models';


import {
    ApiModule
} from '../../../../_services/api.module';

@NgModule({
    imports: [
        CommonModule,
        ApiModule,
        TableModule,
        ActionButtonModule,
        LiveSearchSelectModule,
        DatePickerModule,
        FilterModule,
        WidgetModule,
        RouterModule,
        FormsModule,
        ContainerModule,
        ListContainerModule,
        ReactiveFormsModule,
        SweetAlert2Module.forRoot()
    ],
    declarations: [MoneyListComponent, FormNewComponent],
    exports: [MoneyListComponent, FormNewComponent],
    providers: [
        CurrencyPipe, UnitProviders, InvestorProviders, CategoryProviders, PropertyProviders,
        LesseeProviders
    ]

})
export class MoneyModule { }



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/common/money-module.ts